import React, { createContext, useContext } from "react";
import Technology from "../animation/service/technology.json";
import Marketing from "../animation/service/Marketing.json";
import Design from "../animation/service/Design.json";

const servicesData = {
  design: {
    topHeading: "What Do We Serve?",
    mainHeading:
      "We help you transform a simple idea into an extraordinary digital design vision—elevating creativity into a lasting brand-defining experience.",
    p: "",
    lottieSrc: Design,
    subServices: [
      {
        id: 1,
        name: "Branding",

        p: [
          `Branding is really your company's voice, vibe and visual story and the most crucial part people remember long after they scroll past. It's not just the logo or palette but much more than that,  it's basically how your audience feels about you. As a branding agency, we mold the authentic identities that connect emotionally, build recognition and genuinely inspire trust. Whether you need a logo branding agency or even a rebrand or a fresh tone for your digital marketing agency US audience, we are here to help you craft a brand that stands out, sells smart and stays unforgettable.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/1.webp",
      },
      {
        id: 2,
        name: "Design System",
        p: [
          `Just think of a design system as your product's style bible, the actual rulebook that keeps every screen and pixel consistent. It's got reusable UI components, colors, type and patterns that speed up teamwork and keep everything on brand. As a UI UX design agency, we create scalable systems that help developers and designers move faster without losing soul. From accessibility to component design, our website development agency builds systems that keep your digital experiences cohesive, efficient and ready for growth.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/2.webp",
      },
      {
        id: 3,
        name: "User Research",
        p: [
          `The user research is where the actual guesswork ends and clarity begins. We dig in deep to understand what real users need through interviews, surveys and usability tests, so that every feature feels intentional. Our UX consultancy team turns all those insights into personas, journey maps and even testable hypotheses. It's how our digital marketing agency helps the brands reduce risk, boost retention and make smarter, user friendly decisions. We make sure your roadmap is grounded in reality, not assumptions.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/3.webp",
      },
      {
        id: 4,
        name: `UI Design`,
        p: [
          `The UI design is where the creativity meets usability, while shaping digital experiences that look stunning and work even better. Jumping from layouts and color flow to micro interactions, our UI UX design agency in India focuses on details that delight you and your audience. As part of our content creation services, we design responsive, accessible interfaces that adapt beautifully across devices. Whether you're building a site with artificial intelligence website design or a global website development company, we ensure every touchpoint feels natural and visually consistent.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/4.webp",
      },
      {
        id: 5,
        name: `UI Design Guidelines`,
        p: [
          `UI design guidelines are the behind the scenes magic that keeps every product screen speaking the same language. We build design rulebooks that define spacing, grids, typography and color helping teams move faster and stay aligned. As a UI UX design agency, we craft guidelines that are clear, visual and practical for real world teams. They help your branding agency maintain design consistency, reduce errors and speed up decision making all while keeping your product ready to scale with ease.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/5.webp",
      },
      {
        id: 6,
        name: `UI Development`,
        p: [
          `UI development is where creativity turns into code transforming design ideas into seamless, high performing interfaces. Our developers blend performance, accessibility and design precision using HTML, CSS and modern frameworks. As a website development agency, we ensure your product looks sharp, loads fast and performs beautifully across devices. Partnering closely with our digital marketing agency and UI UX services teams, we build front end systems that are clean, scalable and engineered for long term success.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/6.webp",
      },
      {
        id: 7,
        name: `UX Design`,
        p: [
          `The UX design is really all about experience making every click, swipe and scroll feel very effortless. Going from research to prototyping, our UX consultancy ensures your users find joy, not friction. A great UX is empathy in action that blends creativity with logic. As a UI UX design agency in India, we craft experiences that convert visitors into loyal customers. Whether it's a marketing agency website or an app redesign, our UI UX services deliver products that look good and feel even better to use.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/7.webp",
      },
      {
        id: 8,
        name: `UX Writing`,
        p: [
          `UX writing is the voice guiding your users to be friendly, clear and human. It turns confusion into confidence with words that flow naturally across screens. As part of our content writing services and content production service, we craft copy that fits your brand's tone while making navigation simple. Going from button labels to onboarding text, our UX writers collaborate with our designers to create seamless and trustworthy experiences. You can think of it as micro storytelling that moves users forward with ease.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/8.webp",
      },
      {
        id: 9,
        name: `UX Consultancy`,
        p: [
          `UX consultancy is where strategy meets clarity. We help brands audit their products, uncover friction points and design experiences that just work. Our consultants blend the quick wins with long term goals setting metrics that matter. As a UX consultancy and digital marketing agency, we align all design decisions with the real business outcomes. The results are basically the interfaces that convert better, retain users longer and tell your brand story in the most intuitive way possible.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/9.webp",
      },
      {
        id: 10,
        name: `Animations`,
        p: [
          `Animations really bring your interfaces to life adding movement that feels smooth, natural and emotionally engaging. Going from micro interactions to transitions, we create motion that actually clarifies and not distracts. Our content creation services team works with the explainer video production experts to design animations that simplify any complex ideas. Whether for corporate videos, product photography shoots or app UI, our animations add polish and purpose in order to help your brand feel human, intuitive and memorable across platforms.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/10.webp",
      },
      {
        id: 11,
        name: `Illustration`,
        p: [
          `Illustration is all about telling your brand's story through art. It adds warmth, clarity and a touch of emotion to every visual. From hero images and custom characters to simple diagrams, our content creation services and product photography team bring ideas to life in the most engaging way. Working with our branding agency in India is making sure that every color, line and detail truly fits your brand perfectly. No matter if it's for the explainer videos, marketing visuals or app design, our illustrations turn everyday visuals into something truly memorable.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/11.webp",
      },
      {
        id: 12,
        name: `Iconography`,
        p: [
          `Iconography is the silent hero of user experience with small symbols that make navigation effortless. Our UI UX design agency crafts cohesive icon sets that balance clarity, style and meaning. We test icons across cultures and devices, ensuring accessibility and instant understanding. When paired with website development company design systems, these icons elevate brand identity and improve usability. It's detail driven design that makes every interface intuitive, elegant and easy to love.`,
        ],
        imgSrc: "/new-final-data/branding-page/popup-img/12.webp",
        backToPrevious: true,
      },
    ],
  },
  technology: {
    topHeading: "What Do We Serve ?",
    mainHeading:
      "We help you translate  a simple \n idea into an exotic digital \n design  transformation vision.",
    p: "",
    lottieSrc: Technology,
    subServices: [
      {
        id: 1,
        name: "Web Design",
        p: [
          `Web design is how we really shape what people see, feel and do when they land on your website. It truly blends visuals, clarity and flow so visitors know where to go and what exactly to do. As a website development agency, we create all designs that are fast, accessible and truly SEO friendly. Every detail is built for intent, performance and your brand's digital story powered by artificial intelligence website design elements for smarter interactions.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/1.webp",
      },
      {
        id: 2,
        name: "Development",
        p: [
          `Development is where ideas turn into digital experiences. We turn visual designs into fast, secure and scalable platforms built by a trusted website development company. From clean code to smooth deployment, we make sure everything performs reliably. Whether it's a business portal or eCommerce store, our digital marketing agency roots ensure each build drives growth and visibility.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/2.webp",
      },
      {
        id: 3,
        name: "Front-end",
        p: [
          `The front end is where your website really comes to life and it's what people see, click and explore. The layout and buttons to the tiniest animation, it's all about how your brand feels in motion. At our UIUX design agency, we build interfaces that really just flow smoothly, responsive and are easy to use no matter the screen size. Every scroll, tap and hover is designed to feel effortless, like your website just gets what the user wants`,
        ],
        imgSrc:"/new-final-data/web/popup-img/3.webp",
      },
      {
        id: 4,
        name: "Back-end",
        p: [
          `The backend is basically the engine that keeps everything working smoothly. It's where all your data sits, APIs connect and systems stay in sync. As a website development agency, we build strong and secure setups that keep your site stable and fast. Going from smart integrations to everyday automation, we take care of the behind the scenes work so your front end runs effortlessly.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/4.webp",
      },
      {
        id: 5,
        name: "JavaScript",
        p: [
          `JavaScript is what really makes your website come alive with smooth interactions, quick updates and effortless user flows. Our developers love bringing ideas to life using modern frameworks like React and Angular building experiences that are smart, fast and scalable, all powered by a touch of AI brilliance. Whether we're working with a UI/UX design agency in India or a global brand aiming to stand out, we create websites that think, respond and evolve in real time keeping users engaged, curious and coming back for more.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/5.webp",
      },
      {
        id: 6,
        name: "CSS3",
        p: [
          `CSS3 is basically what gives your website its whole vibe, layouts, the colors, the little motions that make everything come alive. With a smart mix of grids, flexbox and responsive design, we make sure your site looks sharp and feels smooth no matter what device someone's on. Since we're a branding agency, we don't just stop at design,  we make sure every color, transition and detail speaks your brand's language, tying beauty and purpose together effortlessly.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/6.webp",
      },
      {
        id: 7,
        name: "Animation",
        p: [
          `Animation adds rhythm and energy guiding focus and shaping emotion. From explainer videos and corporate videos to interactive web elements, we design purposeful motion that tells your story. Our explainer video production team ensures every animation feels natural and meaningful, turning ordinary interfaces into memorable experiences.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/7.webp",
      },
      {
        id: 8,
        name: "CRM",
        p: [
          `CRM connects your business with people organizing leads, automating follow ups and keeping teams aligned. As a digital marketing agency US offering outreach services, we help brands personalize communication through smart automation and analytics. It's about building long term relationships that scale, not just managing contacts.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/8.webp",
      },
      {
        id: 9,
        name: "Angular",
        p: [
          `Angular helps us build structured, enterprise-level applications with power and precision. From dashboards to management systems, we use its modular strength to ensure performance and consistency. Perfect for brands looking for scalability and stability, backed by a performance marketing agency mindset that values both form and function.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/9.webp",
      },
      {
        id: 10,
        name: "React Development",
        p: [
          `React lets us build dynamic interfaces that load faster and feel smoother. From SPAs to dashboards, React keeps your digital experience fluid. As a branding agency in India and UI UX services provider, we use React to create modular, future ready platforms designed for growth, agility and creative control.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/10.webp",
      },
      {
        id: 11,
        name: "WordPress",
        p: [
          `WordPress makes managing your site effortless from simple blogs to complex WooCommerce stores. As a website development company, we specialize in building secure, high performing sites that are easy to manage. Combined with content creation services and SEO, your brand gets a site that's not just beautiful but built to convert.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/11.webp",
      },
      {
        id: 12,
        name: "eCommerce",
        p: [
          `eCommerce is about creating seamless shopping journeys from browsing to checkout. Our eCommerce photography and product photography shoot teams ensure visuals sell the story, while our developers handle performance and payments. Backed by a digital marketing agency, we optimize conversion, security and flow helping you sell smarter and faster.`,
        ],
        imgSrc:"/new-final-data/web/popup-img/12.webp",
        backToPrevious: true,
      },
    ],
  },
  marketing: {
    topHeading: "What Do We Serve ?",
    mainHeading:
      "Holistic digital solutions that blend marketing expertise with business goals to deliver measurable impact. From branding to performance campaigns, our digital marketing agency helps businesses scale with strategies.",
    p: "",
    lottieSrc: Marketing,
    subServices: [
      {
        id: 1,
        name: "Email Marketing",
        p: [
          `Email marketing isn't just about blasting out messages. It's about starting a real conversation with your audience. You're not just dropping links; you're showing up in their inbox with something that actually matters. From growing your list the right way to segmenting smartly, writing copy that sounds human and making designs that feel easy on the eyes it's all about timing and tone. Maybe it's a warm welcome email, maybe it's a product drop or maybe it's that friendly nudge to check out an abandoned cart. Whatever it is, every message should feel personal, not like another "hey, buy this" notification. At our digital marketing agency, we mix creativity, empathy and automation to make sure every email feels like it's written just for them.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/1.webp",
      },
      {
        id: 2,
        name: "PPC Campaign",
        p: [
          `Just think of PPC as your brand's shortcut to the spotlight showing up right when people are ready to click, buy or explore. It's not just about running ads, it's about running the right ones. We mix targeted keywords with thumb-stopping ad copy and clever bidding strategies so that every click actually means something. Whether it's Google, Meta or LinkedIn, our PPC agency focuses on campaigns that convert, not just attract random traffic. We love digging into A/B tests, audience signals and perfect timing (yep, even down to the hour) to make sure your budget works hard for you. Every ad we run tells a story one that connects data to real revenue and proves that performance marketing can be both powerful and personal.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/2.webp",
      },
      {
        id: 3,
        name: "SEO",
        p: [
          `SEO is the quiet engine that truly keeps your website visible, trustworthy and easy to find. Well, it's not just about keywords but also about answering real questions your customers ask. Going from fixing technical issues and improving speed to building backlinks and optimizing content, we handle it all. As a reliable SEO agency and website development company, we make sure your site stays fast, structured and loved by both users and Google. Our approach is long-term and people first because sustainable SEO isn't about hacks, it's about helping people find you, effortlessly.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/3.webp",
      },
      {
        id: 4,
        name: "SMM",
        p: [
          `Social media isn't just about tossing up a post and calling it a day, it's about creating real connections. It's where your brand gets to talk, listen and actually vibe with your audience. We help you build that by turning your pages into lively little communities with stories that feel authentic, content that rides the trends (without trying too hard) and engagement that actually means something. Whether it's LinkedIn, Instagram, Facebook or X, we truly plan every post with intention and a touch of personality. As a creative digital marketing agency in the US, we blend storytelling, smart strategy and paid campaigns that feel organic. From bold brand launches to fun influencer tie-ups, we make sure people don't just scroll by, they stop, smile and remember you.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/4.webp",
      },
      {
        id: 5,
        name: "SMO",
        p: [
          `SMO is kinda like your secret weapon for standing out without shouting for attention. It's all about making your brand look good and feel real on every platform. From tweaking bios and picking the right hashtags to nailing those captions and perfecting post timing, we handle the details that make the difference. When it comes to getting your name out there, our influencer marketing agency steps in to amplify your voice through collaborations that actually feel natural — not scripted or forced. With consistent branding, SEO-friendly captions and visuals that pop, we make your social presence shine brighter and your audience stop mid-scroll.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/5.webp",
      },
      {
        id: 6,
        name: "Content",
        p: [
          `Every great brand starts with a story and we help you tell it right. From blogs and social posts to web copy and guides, our content creation services focus on making people feel something. We mix clarity with creativity so your message connects and converts. Backed by strong SEO and thoughtful structure, our content writing services turn browsers into believers. Whether it's for an ecommerce brand or a branding agency in India, we make every word count and every piece of content feel like a conversation.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/6.webp",
      },
      {
        id: 7,
        name: "Video Marketing",
        p: [
          `Video isn't just content, it's emotion in motion. From explainer videos that simplify ideas to storytelling that sticks, we help your brand connect visually. Our explainer video production and corporate videos are designed to inform, inspire and engage all while fitting your platform perfectly. Whether it's YouTube, Instagram or your website, every frame is optimized for attention and action. With our content production service, we handle everything scripting, shooting, editing turning your vision into videos that move people and metrics.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/7.webp",
      },
      {
        id: 8,
        name: "ASO",
        p: [
          `Your app definitely deserves to be noticed and that's exactly what ASO is all about. We take care of the little things that make a big difference from titles and descriptions to visuals and reviews helping your app climb the charts and reach real users. With smart keyword research, creative copy and a bit of A/B testing magic, we make sure every detail actually matters. As a digital marketing agency that knows the ins and outs of app store optimization, we focus on making your listings convert and your users stick around. It's a mix of data, design and strategy because getting seen is great but keeping people engaged is where the real win lies.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/8.webp",
      },
      {
        id: 9,
        name: "Brand Purpose",
        backToPrevious: true,
        p: [
          `When it comes to a brand's purpose it's more than a tagline, it's your heartbeat. It's the "why" behind every campaign, design and message. As a branding agency and logo branding agency, we help you find and express the core with authenticity. You know purpose really shapes how you show up in your content, your community and even in your culture. Going from defining values to aligning visuals, we make sure your story feels human and not corporate. When your purpose is clear, your brand doesn't just sell,  it inspires.`
        ],
        imgSrc: "/new-final-data/marketing/popup-img/9.webp",
      }
    ]
  },
};

// Create the context
const ServiceDataContext = createContext(undefined);

// Provider component
export const ServiceDataProvider = ({ children }) => {
  // Helper functions to get services data
  const getServiceByCategory = (category) => {
    return servicesData[category] || [];
  };

  const getServiceById = (category, id) => {
    const categoryServices = servicesData[category] || [];
    return categoryServices.subServices.find(
      (service) => service.id === parseInt(id)
    );
  };

  const getAllServices = () => {
    return servicesData;
  };

  // Get all services as a flat array with category info
  const getAllServicesFlat = () => {
    const flatServices = [];
    Object.keys(servicesData).forEach((category) => {
      servicesData[category].forEach((service) => {
        flatServices.push({
          ...service,
          category,
        });
      });
    });
    return flatServices;
  };

  const contextValue = {
    servicesData,
    getServiceByCategory,
    getServiceById,
    getAllServices,
    getAllServicesFlat,
  };

  return (
    <ServiceDataContext.Provider value={contextValue}>
      {children}
    </ServiceDataContext.Provider>
  );
};

// Custom hook to use the context
export const useServiceData = () => {
  const context = useContext(ServiceDataContext);
  if (context === undefined) {
    throw new Error("useServiceData must be used within a ServiceDataProvider");
  }
  return context;
};

export default ServiceDataProvider;
